import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-students-archived',
    templateUrl: './students-archived.component.html',
    styleUrls: ['./students-archived.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StudentsArchivedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() {
  }

}
